<ng-content select="app-video-player"> </ng-content>
<div
    class="process-container"
    *ngIf="uploading || uploadErro || inConversionQueue() || videoProcessing() || videoProcessErro()"
>
    <div class="process" *ngIf="uploading">
        <img [src]="gif" class="process-gif" />
        <div class="process-content" *ngIf="uploadPercentage != 100">
            <h3>Enviando arquivo...</h3>
        </div>
        <div class="process-content" *ngIf="uploadPercentage != 100">
            <mat-progress-bar
                mode="determinate"
                [value]="uploadPercentage"
                color="primary"
                [class.fallback-progress]="uploadPercentage > 0 && uploadPercentage < 10">
            </mat-progress-bar>
            <span class="percentage">{{ uploadPercentage }}%</span>
        </div>
        <div class="process-content" *ngIf="uploadPercentage != 100 && uploadSpeed > 0">
            <h4>{{ humanFileSize(uploadSpeed) }}/s</h4>
        </div>

        <div class="process-content" *ngIf="uploadPercentage == 100">
            <h4>Registrando arquivo</h4>
        </div>

        <div class="process-content">
            <span
                style="
                    color: red;
                    animation: blink-animation 2s steps(5, start) infinite;
                    -webkit-animation: blink-animation 2s steps(5, start) infinite;
                    margin-top: 5px;
                "
                >* Não saia desta tela enquanto o envio não for encerrado</span
            >
        </div>
    </div>
    <div class="process error" *ngIf="uploadErro">
        <h4>Houve um error ao enviar seu arquivo...<mat-icon color="primary">sentiment_very_dissatisfied</mat-icon></h4>
        <h5>Tente novamente e se o erro persistir contate o suporte!</h5>
    </div>

    <div class="process" *ngIf="inConversionQueue()">
        <img [src]="gif" class="process-gif" />
        <div class="process-content">
            <h3>Carregando Arquivo</h3>
        </div>
    </div>

    <div class="process uploading" *ngIf="videoProcessing()">
        <img [src]="gif" class="process-gif" />
        <div class="process-content">
            <h4>{{ videoProcess?.status || 'Iniciando conversão do vídeo...' }}</h4>
        </div>
        <div class="process-content">
            <mat-progress-bar
                mode="determinate"
                [value]="videoProcess?.percentualConclusao"
                color="primary"
            ></mat-progress-bar>
            <span class="percentage">{{ videoProcess?.percentualConclusao }}%</span>
        </div>
    </div>

    <div class="process error" *ngIf="videoProcessErro()">
        <h4>
            Houve um error ao processar seu arquivo...<mat-icon color="primary">sentiment_very_dissatisfied</mat-icon>
        </h4>
        <div class="process-content">{{ videoProcess.errorMessage }}</div>
    </div>
</div>

<app-video-player
    *ngIf="showVideoPlayer()"
    [src]="src"
    [thumbnail]="thumbnail"
    [externalMediaUrl]="externalMediaUrl"
    [InitialTimeInSec]="initialTimeInSec"
    [blockAdvanceVideo]="blockAdvanceVideo"
    (VideoEvent)="videoEventEmitter.emit($event)"
>
</app-video-player>

<div class="progress-bar-container" *ngIf="uploading && !uploadErro">
    <div class="progress-bar-background">
        <div
            class="progress-bar-fill"
            [style.width.%]="uploadPercentage"
            [attr.data-percentage]="uploadPercentage"
            [class.progress-stalled]="uploadPercentage === 0 && uploading">
        </div>
    </div>
</div>
